import React from "react";
import ManufacturedProductEventItem from "./ManufacturedProductEventItem";

export default function DayCell({
  day,
  isExpanded,
  onClick,
  onMoreClick,
  onShowLessClick,
  openEventDetails,
}) {
  const events = Array.isArray(day.events) ? day.events : [];
  const inline = isExpanded ? events : events.slice(0, 2);

  const baseBg = day.isCurrentMonth ? "bg-white" : "bg-gray-50";
  const todayClass = day.isToday ? "bg-yellow-50 ring-2 ring-yellow-400" : "";
  const selectedClass =
    !day.isToday && day.isSelected ? "ring-2 ring-blue-400" : "";

  return (
    <div
      className={`border p-2 min-h-20 ${baseBg} ${todayClass} ${selectedClass}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === "Enter" && onClick()}
    >
      <time dateTime={day.date} className="block text-sm font-medium mb-1">
        {day.date.split("-").pop()}{" "}
        {day.totalManufacturedWeight > 0 && (
          <span className="text-xs font-medium">
            - {day.totalManufacturedWeight} kg
          </span>
        )}
        {day.stockInWeight > 0 && (
          <span className="text-xs font-medium">- {day.stockInWeight} kg</span>
        )}
      </time>

      <ol className="space-y-1">
        {inline.map((ev) => (
          <li key={ev.id}>
            <ManufacturedProductEventItem
              event={ev}
              // onClick={(e) => {
              //   e.stopPropagation();
              //   openEventDetails(ev);
              // }}
            />
          </li>
        ))}
        {events.length > 2 && !isExpanded && (
          <li>
            <button
              className="text-sm text-blue-600"
              onClick={(e) => onMoreClick(e, day)}
            >
              + {events.length - 2} more
            </button>
          </li>
        )}
        {isExpanded && events.length > 2 && (
          <li>
            <button
              className="text-sm text-gray-600"
              onClick={(e) => onShowLessClick(e)}
            >
              Show less
            </button>
          </li>
        )}
      </ol>
    </div>
  );
}
